import { $showFps, initShowFps } from "../../state/fps";

/** The frame rate under the coordinates, for checking phones by hand (spec 2p §3.7): ?fps=1 or the settings switch. */
export function mountFps(root: HTMLElement, engine: { getFps(): number }, search: string = location.search): void {
  initShowFps(search);
  const el = document.createElement("div");
  el.className = "fps";
  root.appendChild(el);
  $showFps.subscribe((on) => { el.hidden = !on; });
  setInterval(() => { if (!el.hidden) el.textContent = `${Math.round(engine.getFps())} fps`; }, 500);
}
